import { Sparkles, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useEmailDomainStatus } from '../../lib/hooks/useEmailDomainStatus';
import { useSettingsStore } from '../../lib/stores/settingsStore';
import { translations } from '../../lib/i18n/translations';

/**
 * Wave 3.6 — Banner top-page persistente per org legacy SendGrid.
 * Mostrato SOLO se needsMigration=true (hasLegacy && !hasMailjetVerified).
 * Non dismissible (sparisce solo quando user verifica dominio Mailjet).
 * Notion-style sobrio.
 */
export function MigrationBanner() {
  const { needsMigration, loading } = useEmailDomainStatus();
  const { settings } = useSettingsStore();
  const t = translations[settings?.language || 'en'].settings.integrations.emailMigration;

  if (loading || !needsMigration) return null;

  return (
    <div className="sticky top-0 z-40 bg-black/5 border-b border-black/10 px-6 py-3">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <Sparkles className="h-4 w-4 text-black/70 flex-shrink-0" />
          <p className="text-sm text-black">
            <span className="font-medium">{t.banner.title}</span>{' '}
            <span className="text-black/60">{t.banner.subtitle}</span>
          </p>
        </div>
        <Link
          to="/settings"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-black text-white rounded text-xs font-medium hover:bg-black/80 flex-shrink-0"
        >
          {t.banner.cta}
          <ArrowRight className="h-3 w-3" />
        </Link>
      </div>
    </div>
  );
}
